module.exports = __webpack_public_path__ + "img/billmenu3.6ab25c41.png";